export interface AccountEndpointsProps {
  get_account: () => string; // 회원 정보 조회
  update_seller_account: () => string; // 회원 정보 수정
  update_buyer_account: () => string; // 회원 정보 수정
  delete_account: () => string; // 회원 탈퇴
  reset_password: () => string; // 비밀번호 재설정
}

export const AccountEndpoints: AccountEndpointsProps = {
  get_account: () => `api/member/accounts`, // 회원 정보 조회
  update_seller_account: () => `api/seller/accounts`, // 회원 정보 수정
  update_buyer_account: () => `api/buyer/accounts`, // 회원 정보 수정
  delete_account: () => `api/member/accounts`, // 회원 탈퇴
  reset_password: () => `api/member/accounts/password`, // 비밀번호 재설정
};

export default AccountEndpoints;
